import { create } from 'zustand';

// Bridges the gap between changing the avatar on the dashboard and the header
// picking it up. Both read `users.image` off the session, and the server action
// drops the session cookie cache so the next request is already correct — but
// the render that follows the action still runs on the request that carried the
// stale cookie, so without this the header would lag by one navigation.
//
// Deliberately not persisted: the override is only ever meaningful next to the
// server value it was derived from, which `resolveAvatarUrl` checks.
type AvatarState = {
  override: string | null;
  basedOn: string | null;
  hasOverride: boolean;
  setAvatar: (basedOn: string | null, url: string | null) => void;
};

export const useAvatarStore = create<AvatarState>()((set) => {
  return {
    override: null,
    basedOn: null,
    hasOverride: false,
    setAvatar: (basedOn: string | null, url: string | null) => {
      return set(() => {
        return { basedOn, override: url, hasOverride: true };
      });
    }
  };
});

// Derives the URL to render: the local override wins only until the server
// catches up with the value it was based on, after which it is ignored.
export function resolveAvatarUrl(state: AvatarState, serverUrl: string | null): string | null {
  if (state.hasOverride && state.basedOn === serverUrl) {
    return state.override;
  }

  return serverUrl;
}
